import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Role } from '../models/user-manager/roles';
import { ApiResponse } from '@card-software/library';

@Injectable({
  providedIn: 'root',
})
export class RolesProxyService {
  private baseUrl = `${environment.proxyUrls.userMasterApi}/api/v1/roles`;
  constructor(private httpClient: HttpClient) {}

  getAllRoles(): Observable<ApiResponse<Role[]>> {
    return this.httpClient.get<ApiResponse<Role[]>>(`${this.baseUrl}/all`);
  }

  getRoleById(id: string): Observable<ApiResponse<Role>> {
    return this.httpClient.get<ApiResponse<Role>>(`${this.baseUrl}/${id}`);
  }

  createRole(role: Role): Observable<ApiResponse<Role>> {
    return this.httpClient.post<ApiResponse<Role>>(`${this.baseUrl}`, role);
  }

  updateRole(role: Role): Observable<ApiResponse<Role>> {
    return this.httpClient.put<ApiResponse<Role>>(`${this.baseUrl}/${role.id}`, role);
  }

  deleteRole(id: string) {
    return this.httpClient.delete<ApiResponse<string>>(`${this.baseUrl}/${id}`);
  }
}
